import { AssetsService } from "app/services/AssetsService";
import {
    StyledBanner,
    StyledProminentBanner,
} from "app/pages/digital-suite/home-page/components/InviteUsers/Banner/InviteUsersBanner.styled";

interface IInviteUsersBannerProps {
    onClick: () => void;
    onClose: () => void;
    title: string;
    subtitle: string;
    buttonText: string;
    isProminent?: boolean;
}

export const InviteUsersBanner: React.FC<IInviteUsersBannerProps> = ({
    onClick,
    onClose,
    title,
    subtitle,
    buttonText,
    isProminent,
}) => {
    return (
        <>
            {isProminent ? (
                <StyledProminentBanner
                    title={title}
                    subtitle={subtitle}
                    buttonText={buttonText}
                    onButtonClick={() => onClick()}
                    onCloseClick={() => onClose()}
                    buttonType="inverted"
                    buttonIconName="share-new"
                />
            ) : (
                <StyledBanner
                    title={title}
                    subtitle={subtitle}
                    buttonText={buttonText}
                    onButtonClick={() => onClick()}
                    onCloseClick={() => onClose()}
                    buttonType="outlined"
                    buttonIconName="share-new"
                    iconImagePath={AssetsService.assetUrl("/images/homepage/invite-users-banner-Illustration.svg")}
                    iconImageHeight={56}
                    iconImageWidth={56}
                />
            )}
        </>
    );
};
